import { create } from 'zustand';

// Auth store mirrors AuthContext for components that prefer Zustand selectors.
// AuthContext remains the source of truth and writes here on auth events;
// this store is a non-persisted view (Cognito session is the durable record).
const useAuthStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  setAuth: (user) => set({ user, isAuthenticated: true }),
  clearAuth: () => set({ user: null, isAuthenticated: false }),
}));

export default useAuthStore;
